export default function Style(theme) {
    const style = {
        list: {
          width: 250,
        },
        fullList: {
          width: 'auto',
        },
        link: {
          textDecoration: 'none',
          color: '#000'
        }
      }
    return style
}